import { createContext, useContext, useEffect, useState } from "react"
import Portfolio from "../models/Portfolio"
import PortAccount from "../models/PortAccount"

type TPortfolioConext = {
    portfolio:Portfolio
}
const PortfolioContext = createContext<TPortfolioConext>({portfolio:PortAccount.i.portfolio})
const usePortfolio = () => useContext(PortfolioContext)

export default usePortfolio

export function PortfolioProvider(props:{children:any}) {
    const [portfolio,setPortfolio] = useState<Portfolio>(PortAccount.i.portfolio)
    useEffect(() => {
        PortAccount.i.on("refresh", setPortfolio)
        return () => {PortAccount.i.removeListener("refresh", setPortfolio)}
    }, [])  
    return <PortfolioContext.Provider value={{portfolio}}>
        {props.children}
    </PortfolioContext.Provider>
}
